import { apiClient } from '../../../api/axios';
import { CONNECTOR_CONFIG_BASE } from '../constants/connectorsApi';

const base = `${CONNECTOR_CONFIG_BASE}/connectors`;

export const listConnectors = async () => {
  const { data } = await apiClient.get(base);

  return data.connectors || [];
};

export const createConnector = async (payload) => {
  const { data } = await apiClient.post(base, payload);

  return data;
};

export const getConnector = async (connectorKey) => {
  const { data } = await apiClient.get(`${base}/${encodeURIComponent(connectorKey)}`);

  return data;
};

export const updateConnector = async (connectorKey, payload) => {
  const { data } = await apiClient.patch(`${base}/${encodeURIComponent(connectorKey)}`, payload);

  return data;
};

export const listVersions = async (connectorKey) => {
  const { data } = await apiClient.get(`${base}/${encodeURIComponent(connectorKey)}/versions`);

  return data.versions || [];
};

export const getVersion = async (connectorKey, versionNumber) => {
  const { data } = await apiClient.get(`${base}/${encodeURIComponent(connectorKey)}/versions/${versionNumber}`);

  return data;
};

export const createVersion = async (connectorKey, payload) => {
  const { data } = await apiClient.post(`${base}/${encodeURIComponent(connectorKey)}/versions`, payload);

  return data;
};

export const updateVersion = async (connectorKey, versionNumber, payload) => {
  const { data } = await apiClient.put(
    `${base}/${encodeURIComponent(connectorKey)}/versions/${versionNumber}`,
    payload,
  );

  return data;
};

export const previewVersion = async (connectorKey, versionNumber, payload) => {
  const { data } = await apiClient.post(
    `${base}/${encodeURIComponent(connectorKey)}/versions/${versionNumber}/preview`,
    payload,
  );

  return data;
};

export const publishVersion = async (connectorKey, versionNumber) => {
  const { data } = await apiClient.post(
    `${base}/${encodeURIComponent(connectorKey)}/versions/${versionNumber}/publish`,
  );

  return data;
};

export const listSchemaTargets = async () => {
  const { data } = await apiClient.get(`${CONNECTOR_CONFIG_BASE}/schemas/targets`);

  return data;
};

export const getRequiredFields = async (target, marminApiVersion) => {
  const { data } = await apiClient.get(
    `${CONNECTOR_CONFIG_BASE}/schemas/${encodeURIComponent(target)}/${marminApiVersion}/required-fields`,
  );

  return data;
};

export const getFieldCatalog = async (target, marminApiVersion) => {
  const { data } = await apiClient.get(
    `${CONNECTOR_CONFIG_BASE}/schemas/${encodeURIComponent(target)}/${marminApiVersion}/fields`,
  );

  return data;
};

export function getApiErrorMessage(error) {
  const data = error?.response?.data;
  if (!data) {
    return error?.message || 'Request failed';
  }

  if (data.missing?.length) {
    return `${data.error || 'Required fields missing'}: ${data.missing.join(', ')}`;
  }

  return data.error || data.message || 'Request failed';
}
